import { FC } from "react";
import { useLang } from "./Metronici18n";
import { IntlProvider } from "react-intl";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/fr";

import frThemeMessages from "./messages/fr.json";
import enThemeMessages from "./messages/en.json";
import frMessages from "../../lang/fr.json";
import enMessages from "../../lang/en.json";
import { WithChildren } from "../../_metronic/helpers";

const allMessages = {
    en: { ...enThemeMessages, ...enMessages },
    fr: {
        ...frThemeMessages,
        ...frMessages,
    },
};

const I18nProvider: FC<WithChildren> = ({ children }) => {
    const locale = useLang();
    const messages = allMessages[locale];

    return (
        <IntlProvider locale={locale} messages={messages}>
            {children}
        </IntlProvider>
    );
};

export { I18nProvider };
